import React from "react";
import { PageHero } from "../components/PageShells";
import FAQSection from "../components/FAQSection";

const FAQ = () => (
  <main data-testid="faq-page">
    <PageHero
      eyebrow="FAQ"
      title="Alle antwoorden op een rij."
      subtitle="Mis je een antwoord? Onze adviseurs helpen je graag verder via telefoon, e-mail of WhatsApp."
    />
    <FAQSection />
  </main>
);

export default FAQ;
